.modal {
  min-width: 500px;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  justify-content: space-between;
}

.body {
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-height: unset !important;
}
